<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";

import animationData from "@/components/widgets/uetqnvvg.json";
import UserService from "@/services/user.service";
import { Skeletor } from "vue-skeletor";

export default {
    page: {
        title: "مشاهده سفارش",
    },

    data() {
        return {
            title: "مشاهده سفارش",
            order_id: false,
            order: {},
            orderSummary: [],
            defaultOptions: { animationData: animationData },
            isLoading: true
        };
    },
    created() {
        this.order_id = this.$route.params.order_id;
        this.fetchPromises()
    },
    methods: {
        fetchPromises() {
            Promise.all([
                this.fetchOrder(),
            ])
        },
        fetchOrder() {
            return UserService.viewOrder(this.order_id)
                .then((response) => {
                    let {data} = response;
                    this.order = data;
                    this.orderSummary = data.line_items;
                    this.isLoading = false;
                });
        },
    },
    components: {
        Layout,
        PageHeader,
        Skeletor
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" />
        <div class="row">
            <div class="col-xl-9">
                <div class="card">
                    <div class="card-header">
                        <div class="d-flex align-items-center">
                            <h5 class="card-title flex-grow-1 mb-0" v-if="!isLoading">
                                سفارش #{{order.id}}
                            </h5>
                            <h5 class="card-title flex-grow-1 mb-0" v-else>
                                <Skeletor width="100px" />
                            </h5>
                            <div class="flex-shrink-0" v-if="false">
                                <router-link to="/invoices/detail" class="btn btn-success btn-sm">
                                    <i class="ri-download-2-fill align-middle me-1"></i>
                                    Invoice
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">

                        <div v-if="!isLoading" class="order-gold-raw-price">
                            <div class="label">قیمت طلا زمان ثبت این سفارش:</div>
                            <div v-html="formatMoney(order.gold_raw_price)"></div>
                        </div>
                        <div v-else class="order-gold-raw-price">
                            <Skeletor width="200px" />
                        </div>
                        <div class="table-responsive">
                            <table v-if="!isLoading" class="table table-nowrap align-middle table-borderless mb-0">
                                <thead class="table-light text-muted">
                                    <tr>
                                        <th scope="col">محصول</th>
                                        <th scope="col">تعداد</th>
                                        <th scope="col">قیمت محصول</th>
                                        <th scope="col">قیمت فروش</th>
                                        <th scope="col" class="text-end">سهم شما</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item, index) of orderSummary" :key="index">
                                    <td>
                                        <div class="d-flex">
                                            <div class="flex-shrink-0 avatar-md bg-light rounded p-1">
                                                <img :src="item.image.src" alt="" class="img-fluid d-block"/>
                                            </div>
                                            <div class="flex-grow-1 ms-3">
                                                <h5 class="fs-15">
                                                    <a href="#" class="link-primary">{{item.name}}</a>
                                                    <router-link to="/ecommerce/product-details" class="link-primary" v-if="false">{{ item.product }}</router-link>
                                                </h5>

                                                <p class="text-muted mb-0" v-for="(meta, index) of item.meta_data" :key="index">
                                                    {{ meta.display_key }}: <span class="fw-medium">{{ meta.display_value }}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{ item.quantity }}</td>
                                    <td v-html="formatMoney(item.price)"></td>
                                    <td  v-html="formatMoney(item.total)"></td>
                                    <td class="fw-medium text-end" v-html="formatMoney(item.income)"></td>
                                </tr>

                                <tr class="border-top border-top-dashed">
                                    <td colspan="3"></td>
                                    <td colspan="2" class="fw-medium p-0">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr v-if="false">
                                                    <td>Sub Total :</td>
                                                    <td class="text-end">$359.96</td>
                                                </tr>
                                                <tr class="border-top border-top-dashed">
                                                    <th scope="row">مجموع:</th>
                                                    <th class="text-end" v-html="formatMoney(order.total)"></th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <table v-else class="table table-nowrap align-middle table-borderless mb-0">
                                <thead class="table-light text-muted">
                                    <tr>
                                        <th scope="col">محصول</th>
                                        <th scope="col">تعداد</th>
                                        <th scope="col">قیمت محصول</th>
                                        <th scope="col">قیمت فروش</th>
                                        <th scope="col" class="text-end">سهم شما</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) of 4" :key="index">
                                        <td>
                                            <div class="d-flex">
                                                <Skeletor width="64px" height="64px" style="border-radius: 50%;" />
                                            </div>
                                        </td>
                                        <td>
                                            <Skeletor width="100px" />
                                        </td>
                                        <td>
                                            <Skeletor width="100px" />
                                        </td>
                                        <td>
                                            <Skeletor width="100px" />
                                        </td>
                                        <td class="fw-medium text-end">
                                            <Skeletor width="100px" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!--end card-->
            </div>
            <!--end col-->
            <div class="col-xl-3">

                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title mb-0 justify-content-between d-flex">
                            جزییات سفارش
                            <i class="ri-secure-payment-line align-bottom me-1 text-muted"></i>
                        </h5>
                    </div>
                    <div class="card-body" v-if="!isLoading">
                        <div class="d-flex align-items-center mb-2 justify-content-between">
                            <div class="flex-shrink-0">
                                <p class="text-muted mb-0">تاریخ سفارش:</p>
                            </div>
                            <div class="ms-2">
                                <div class="date-time-wrapper mb-0">
                                    {{order.created_jalali_date}}
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-2 justify-content-between">
                            <div class="flex-shrink-0">
                                <p class="text-muted mb-0">وضعیت سفارش</p>
                            </div>
                            <div class="ms-2">
                                <h6 class="mb-0" v-html="orderStatusLabel(order.status)"></h6>
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-2 justify-content-between">
                            <div class="flex-shrink-0">
                                <p class="text-muted mb-0">شعبه</p>
                            </div>
                            <div class="ms-2">
                                <h6 class="mb-0">{{order.source_branch.name}}</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-else>
                        <div class="d-flex align-items-center mb-2 justify-content-between">
                            <div class="flex-shrink-0">
                                <p class="text-muted mb-0">تاریخ سفارش:</p>
                            </div>
                            <div class="ms-2">
                                <Skeletor width="100px" />
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-2 justify-content-between">
                            <div class="flex-shrink-0">
                                <p class="text-muted mb-0">وضعیت سفارش</p>
                            </div>
                            <div class="ms-2">
                                <Skeletor width="100px" />
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-2 justify-content-between">
                            <div class="flex-shrink-0">
                                <p class="text-muted mb-0">شعبه</p>
                            </div>
                            <div class="ms-2">
                                <Skeletor width="100px" />
                            </div>
                        </div>
                    </div>
                </div>
                <!--end card-->
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </Layout>
</template>
